export const PUBLIC_PAGE_TRANSLATIONS = {
  es: {
    home: {
      status_tag: '// TIENDA & SALA DE JUEGOS //',
      explore: 'Explorar',
    },
    store: {
      loading_cards_error: 'No se pudieron cargar las cartas',
      view_all_cards: 'Ver todas las {count} cartas ->',
      searching: 'Buscando...',
      sort_price_asc: 'Precio: menor a mayor',
      sort_price_desc: 'Precio: mayor a menor',
      sort_rating: 'Mejor valorados',
      min_price: 'Precio minimo',
      max_price: 'Precio maximo',
      min_rating: 'Valoracion minima',
      rentable_only: 'Solo alquiler',
      in_stock_only: 'Solo en stock',
      clear: 'Limpiar',
      products_count: '{count} productos',
      rent_badge: 'Alquiler',
    },
    eventDetail: {
      check_in_success: 'Check-in completado',
      registration_cancelled: 'Inscripcion cancelada',
      registration_success: 'Inscrito correctamente',
      participant_checked_in: 'Participante registrado',
      bracket_generated: 'Bracket generado',
      cannot_add_after_start: 'No puedes anadir participantes con el torneo iniciado.',
      add_temporary_participant_prompt: 'Introduce el nombre del participante temporal:',
      participant_added: 'Participante anadido',
      remove_participant_confirm: 'Eliminar participante del torneo?',
      participant_removed: 'Participante eliminado',
      result_recorded: 'Resultado registrado',
      swiss_started: 'Suizo iniciado',
      swiss_completed: 'Torneo suizo completado',
      swiss_new_round: 'Nueva ronda suiza generada',
      groups_advanced: 'Fase de grupos avanzada',
      cancel_tournament_confirm: 'Cancelar el torneo actual? Se eliminara la competicion y los participantes volveran a la pestana de participantes.',
      tournament_cancelled: 'Torneo cancelado',
      finalize_tournament_confirm: 'Finalizar torneo? Se consolidaran premios y finanzas pendientes.',
      tournament_finalized: 'Torneo finalizado',
      delete_tournament_confirm: 'Eliminar torneo? Se borrara todo lo relacionado con este torneo.',
      tournament_deleted: 'Torneo eliminado',
      not_found: 'Evento no encontrado',
      back_to_tournaments: 'Volver a torneos',
      info_tab: 'Informacion',
      participants_tab: 'Participantes',
      competition_tab: 'Competicion',
      details_title: 'Detalles del Evento',
      entry_fee_label: 'Entrada:',
      tournament_format_label: 'Formato del torneo',
      organization_title: 'Organizacion actual de participantes',
      applied_format: 'Formato aplicado:',
      group_label: 'Grupo',
      format_swiss_title: 'Sistema Suizo',
      format_swiss_body: 'Emparejamientos por rondas segun rendimiento acumulado. La siembra inicial usa ranking del TCG correspondiente.',
      format_league_title: 'Liga (Round-Robin)',
      format_league_body: 'Todos contra todos en rondas planificadas. El sistema puede generar el calendario automaticamente.',
      format_groups_title: 'Grupos + Eliminacion',
      format_groups_body: 'Reparto inicial en grupos balanceados y fase eliminatoria posterior entre clasificados.',
      format_custom_body: 'Formato personalizado.',
    },
    events: {
      type_tournament: 'Torneo',
      type_casual: 'Casual',
      type_draft: 'Draft',
      type_sealed: 'Sellado',
      type_league: 'Liga',
    },
  },
  en: {
    home: {
      status_tag: '// STORE & GAME LOUNGE //',
      explore: 'Explore',
    },
    store: {
      loading_cards_error: 'Could not load cards',
      view_all_cards: 'View all {count} cards ->',
      searching: 'Searching...',
      sort_price_asc: 'Price: low to high',
      sort_price_desc: 'Price: high to low',
      sort_rating: 'Best rated',
      min_price: 'Min price',
      max_price: 'Max price',
      min_rating: 'Min rating',
      rentable_only: 'Rentable only',
      in_stock_only: 'In stock only',
      clear: 'Clear',
      products_count: '{count} products',
      rent_badge: 'Rent',
    },
    eventDetail: {
      check_in_success: 'Checked in successfully',
      registration_cancelled: 'Registration cancelled',
      registration_success: 'Successfully registered',
      participant_checked_in: 'Participant checked in',
      bracket_generated: 'Bracket generated',
      cannot_add_after_start: 'Cannot add participants after tournament has started.',
      add_temporary_participant_prompt: 'Enter temporary participant name:',
      participant_added: 'Participant added',
      remove_participant_confirm: 'Remove participant from tournament?',
      participant_removed: 'Participant removed',
      result_recorded: 'Result recorded',
      swiss_started: 'Swiss started',
      swiss_completed: 'Swiss tournament completed',
      swiss_new_round: 'New swiss round generated',
      groups_advanced: 'Group stage advanced',
      cancel_tournament_confirm: 'Cancel current tournament? Competition will be cleared and participants will return to participants tab.',
      tournament_cancelled: 'Tournament cancelled',
      finalize_tournament_confirm: 'Finalize tournament? Pending prizes and finance entries will be committed.',
      tournament_finalized: 'Tournament finalized',
      delete_tournament_confirm: 'Delete tournament? This will remove all data related to this tournament.',
      tournament_deleted: 'Tournament deleted',
      not_found: 'Event not found',
      back_to_tournaments: 'Back to tournaments',
      info_tab: 'Info',
      participants_tab: 'Participants',
      competition_tab: 'Competition',
      details_title: 'Event Details',
      entry_fee_label: 'Entry Fee:',
      tournament_format_label: 'Tournament format',
      organization_title: 'Current participant organization',
      applied_format: 'Applied format:',
      group_label: 'Group',
      format_swiss_title: 'Swiss System',
      format_swiss_body: 'Round pairings based on cumulative performance. Initial seeding uses ranking points for the tournament TCG.',
      format_league_title: 'League (Round-Robin)',
      format_league_body: 'Everyone plays everyone in planned rounds. The system can auto-generate the schedule.',
      format_groups_title: 'Groups + Elimination',
      format_groups_body: 'Balanced initial group distribution followed by elimination rounds for qualified players.',
      format_custom_body: 'Custom format.',
    },
    events: {
      type_tournament: 'Tournament',
      type_casual: 'Casual',
      type_draft: 'Draft',
      type_sealed: 'Sealed',
      type_league: 'League',
    },
  },
  fr: {
    home: { status_tag: '// BOUTIQUE & SALLE DE JEU //', explore: 'Explorer' },
    store: {
      loading_cards_error: 'Impossible de charger les cartes',
      view_all_cards: 'Voir les {count} cartes ->',
      searching: 'Recherche...',
      sort_price_asc: 'Prix : croissant',
      sort_price_desc: 'Prix : decroissant',
      sort_rating: 'Mieux notes',
      min_price: 'Prix min',
      max_price: 'Prix max',
      min_rating: 'Note min',
      rentable_only: 'Location uniquement',
      in_stock_only: 'En stock uniquement',
      clear: 'Effacer',
      products_count: '{count} produits',
      rent_badge: 'Location',
    },
    eventDetail: {
      check_in_success: 'Check-in effectue',
      registration_cancelled: 'Inscription annulee',
      registration_success: 'Inscription effectuee',
      participant_checked_in: 'Participant valide',
      bracket_generated: 'Bracket genere',
      cannot_add_after_start: 'Impossible dajouter des participants apres le debut du tournoi.',
      add_temporary_participant_prompt: 'Saisissez le nom du participant temporaire :',
      participant_added: 'Participant ajoute',
      remove_participant_confirm: 'Supprimer ce participant du tournoi ?',
      participant_removed: 'Participant supprime',
      result_recorded: 'Resultat enregistre',
      swiss_started: 'Suisse demarre',
      swiss_completed: 'Tournoi suisse termine',
      swiss_new_round: 'Nouveau tour suisse genere',
      groups_advanced: 'Phase de groupes avancee',
      cancel_tournament_confirm: 'Annuler le tournoi actuel ? La competition sera videe et les participants reviendront a longlet participants.',
      tournament_cancelled: 'Tournoi annule',
      finalize_tournament_confirm: 'Finaliser le tournoi ? Les prix et finances en attente seront valides.',
      tournament_finalized: 'Tournoi finalise',
      delete_tournament_confirm: 'Supprimer le tournoi ? Toutes les donnees liees seront effacees.',
      tournament_deleted: 'Tournoi supprime',
      not_found: 'Evenement introuvable',
      back_to_tournaments: 'Retour aux tournois',
      info_tab: 'Infos',
      participants_tab: 'Participants',
      competition_tab: 'Competition',
      details_title: 'Details de l evenement',
      entry_fee_label: 'Inscription :',
      tournament_format_label: 'Format du tournoi',
      organization_title: 'Organisation actuelle des participants',
      applied_format: 'Format applique :',
      group_label: 'Groupe',
      format_swiss_title: 'Systeme suisse',
      format_swiss_body: 'Appariements par rondes selon les performances cumulees. Le classement initial utilise les points du TCG concerne.',
      format_league_title: 'Ligue (Round-Robin)',
      format_league_body: 'Tout le monde affronte tout le monde dans des rondes planifiees. Le systeme peut generer le calendrier automatiquement.',
      format_groups_title: 'Groupes + Elimination',
      format_groups_body: 'Repartition initiale equilibree en groupes suivie dune phase a elimination pour les qualifies.',
      format_custom_body: 'Format personnalise.',
    },
    events: {
      type_tournament: 'Tournoi',
      type_casual: 'Casual',
      type_draft: 'Draft',
      type_sealed: 'Scelle',
      type_league: 'Ligue',
    },
  },
  pt: {
    home: { status_tag: '// LOJA & SALA DE JOGOS //', explore: 'Explorar' },
    store: {
      loading_cards_error: 'Nao foi possivel carregar as cartas',
      view_all_cards: 'Ver todas as {count} cartas ->',
      searching: 'Pesquisando...',
      sort_price_asc: 'Preco: menor para maior',
      sort_price_desc: 'Preco: maior para menor',
      sort_rating: 'Melhor avaliados',
      min_price: 'Preco minimo',
      max_price: 'Preco maximo',
      min_rating: 'Avaliacao minima',
      rentable_only: 'So aluguer',
      in_stock_only: 'So em stock',
      clear: 'Limpar',
      products_count: '{count} produtos',
      rent_badge: 'Aluguer',
    },
    eventDetail: {
      check_in_success: 'Check-in concluido',
      registration_cancelled: 'Inscricao cancelada',
      registration_success: 'Inscricao realizada com sucesso',
      participant_checked_in: 'Participante validado',
      bracket_generated: 'Bracket gerado',
      cannot_add_after_start: 'Nao podes adicionar participantes apos o inicio do torneio.',
      add_temporary_participant_prompt: 'Introduz o nome do participante temporario:',
      participant_added: 'Participante adicionado',
      remove_participant_confirm: 'Remover participante do torneio?',
      participant_removed: 'Participante removido',
      result_recorded: 'Resultado registado',
      swiss_started: 'Suico iniciado',
      swiss_completed: 'Torneio suico concluido',
      swiss_new_round: 'Nova ronda suica gerada',
      groups_advanced: 'Fase de grupos avancada',
      cancel_tournament_confirm: 'Cancelar o torneio atual? A competicao sera limpa e os participantes voltarao para o separador de participantes.',
      tournament_cancelled: 'Torneio cancelado',
      finalize_tournament_confirm: 'Finalizar torneio? Premios e financas pendentes serao confirmados.',
      tournament_finalized: 'Torneio finalizado',
      delete_tournament_confirm: 'Eliminar torneio? Todos os dados relacionados serao removidos.',
      tournament_deleted: 'Torneio eliminado',
      not_found: 'Evento nao encontrado',
      back_to_tournaments: 'Voltar aos torneios',
      info_tab: 'Informacao',
      participants_tab: 'Participantes',
      competition_tab: 'Competicao',
      details_title: 'Detalhes do Evento',
      entry_fee_label: 'Inscricao:',
      tournament_format_label: 'Formato do torneio',
      organization_title: 'Organizacao atual dos participantes',
      applied_format: 'Formato aplicado:',
      group_label: 'Grupo',
      format_swiss_title: 'Sistema Suico',
      format_swiss_body: 'Emparelhamentos por rondas com base no desempenho acumulado. A classificacao inicial usa os pontos do TCG do torneio.',
      format_league_title: 'Liga (Round-Robin)',
      format_league_body: 'Todos jogam contra todos em rondas planeadas. O sistema pode gerar o calendario automaticamente.',
      format_groups_title: 'Grupos + Eliminacao',
      format_groups_body: 'Distribuicao inicial equilibrada em grupos seguida de eliminacao entre os classificados.',
      format_custom_body: 'Formato personalizado.',
    },
    events: {
      type_tournament: 'Torneio',
      type_casual: 'Casual',
      type_draft: 'Draft',
      type_sealed: 'Selado',
      type_league: 'Liga',
    },
  },
  de: {
    home: { status_tag: '// SHOP & SPIELELOUNGE //', explore: 'Entdecken' },
    store: {
      loading_cards_error: 'Karten konnten nicht geladen werden',
      view_all_cards: 'Alle {count} Karten ansehen ->',
      searching: 'Suche...',
      sort_price_asc: 'Preis: aufsteigend',
      sort_price_desc: 'Preis: absteigend',
      sort_rating: 'Bestbewertet',
      min_price: 'Min Preis',
      max_price: 'Max Preis',
      min_rating: 'Min Bewertung',
      rentable_only: 'Nur Vermietung',
      in_stock_only: 'Nur auf Lager',
      clear: 'Zurucksetzen',
      products_count: '{count} Produkte',
      rent_badge: 'Miete',
    },
    eventDetail: {
      check_in_success: 'Check-in abgeschlossen',
      registration_cancelled: 'Anmeldung storniert',
      registration_success: 'Erfolgreich angemeldet',
      participant_checked_in: 'Teilnehmer eingecheckt',
      bracket_generated: 'Bracket erstellt',
      cannot_add_after_start: 'Nach Turnierstart konnen keine Teilnehmer mehr hinzugefugt werden.',
      add_temporary_participant_prompt: 'Name des temporaren Teilnehmers eingeben:',
      participant_added: 'Teilnehmer hinzugefugt',
      remove_participant_confirm: 'Teilnehmer aus dem Turnier entfernen?',
      participant_removed: 'Teilnehmer entfernt',
      result_recorded: 'Ergebnis gespeichert',
      swiss_started: 'Schweizer System gestartet',
      swiss_completed: 'Schweizer Turnier abgeschlossen',
      swiss_new_round: 'Neue Schweizer Runde erstellt',
      groups_advanced: 'Gruppenphase fortgesetzt',
      cancel_tournament_confirm: 'Aktuelles Turnier abbrechen? Der Wettbewerb wird geleert und die Teilnehmer kehren zum Teilnehmer-Tab zuruck.',
      tournament_cancelled: 'Turnier abgebrochen',
      finalize_tournament_confirm: 'Turnier abschliessen? Ausstehende Preise und Finanzeintrage werden verbucht.',
      tournament_finalized: 'Turnier abgeschlossen',
      delete_tournament_confirm: 'Turnier loschen? Alle zugehorigen Daten werden entfernt.',
      tournament_deleted: 'Turnier geloscht',
      not_found: 'Event nicht gefunden',
      back_to_tournaments: 'Zuruck zu den Turnieren',
      info_tab: 'Info',
      participants_tab: 'Teilnehmer',
      competition_tab: 'Wettbewerb',
      details_title: 'Eventdetails',
      entry_fee_label: 'Startgebuhr:',
      tournament_format_label: 'Turnierformat',
      organization_title: 'Aktuelle Teilnehmerorganisation',
      applied_format: 'Angewandtes Format:',
      group_label: 'Gruppe',
      format_swiss_title: 'Schweizer System',
      format_swiss_body: 'Paarungen nach Runden auf Basis der kumulierten Leistung. Die Startsetzung verwendet die Ranglistenpunkte des Turnier-TCGs.',
      format_league_title: 'Liga (Round-Robin)',
      format_league_body: 'Jeder spielt gegen jeden in geplanten Runden. Das System kann den Spielplan automatisch erzeugen.',
      format_groups_title: 'Gruppen + K.-o.',
      format_groups_body: 'Ausgewogene Anfangsverteilung in Gruppen, danach K.-o.-Runden fur qualifizierte Spieler.',
      format_custom_body: 'Benutzerdefiniertes Format.',
    },
    events: {
      type_tournament: 'Turnier',
      type_casual: 'Casual',
      type_draft: 'Draft',
      type_sealed: 'Sealed',
      type_league: 'Liga',
    },
  },
};
